module.exports = __webpack_public_path__ + "static/media/alllogo.a9052fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/customer/alllogo.png
// module id = 383
// module chunks = 0